import { render, staticRenderFns } from "./ResidentFormModal.vue?vue&type=template&id=6ffa37d2&scoped=true&"
import script from "./ResidentFormModal.vue?vue&type=script&lang=js&"
export * from "./ResidentFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffa37d2",
  null
  
)

export default component.exports